import { Scale } from "@pdfking/math"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Stymie, a landscape desk calendar: the year low on its picture; a month under a band of its picture, its name over its grid, the logo and the contact right of it. */
export const Stymie: CalendarDesign = {
  cover: PictureCover({ at: 0.3 }),
  page: ({ gap, language, outer, page, short, year }, month) => {
    const picture = Region(page, 0, 0.72, 1, 1)
    const below = Slice.under(outer, picture.y, gap)
    return [
      Area.picture(picture, month),
      ...Area.month(Region(below, 0, 0, 0.7, 1), month, year, language, Scale(short, 0.08), gap),
      Area.contact(Region(below, 0.76, 0, 1, 1)),
    ]
  },
  pages: "month",
}
